// @ts-nocheck
import { createStyle } from '@gluestack-style/react';

export const Badge = createStyle({
  flexDirection: 'row',
  alignItems: 'center',
  borderRadius: '$md',
  variants: {
    action: {
      error: {
        bg: '$statusErrorSubtle',
        borderColor: '$statusError',
        _icon: {
          color: '$statusError',
        },
        _text: {
          color: '$statusError',
        },
        _dark: {
          bg: '$statusErrorSubtle',
          borderColor: '$statusError',
          _text: {
            color: '$statusError',
          },
          _icon: {
            color: '$statusError',
          },
        },
      },
      warning: {
        bg: '$statusWarningSubtle',
        borderColor: '$statusWarning',
        _icon: {
          color: '$statusWarning',
        },
        _text: {
          color: '$statusWarning',
        },
        _dark: {
          bg: '$statusWarningSubtle',
          borderColor: '$statusWarning',
          _text: {
            color: '$statusWarning',
          },
          _icon: {
            color: '$statusWarning',
          },
        },
      },
      success: {
        bg: '$statusSuccessSubtle',
        borderColor: '$statusSuccess',
        _icon: {
          color: '$statusSuccess',
        },
        _text: {
          color: '$statusSuccess',
        },
        _dark: {
          bg: '$statusSuccessSubtle',
          borderColor: '$statusSuccess',
          _text: {
            color: '$statusSuccess',
          },
          _icon: {
            color: '$statusSuccess',
          },
        },
      },
      info: {
        bg: '$statusInfoSubtle',
        borderColor: '$statusInfo',
        _icon: {
          color: '$statusInfo',
        },
        _text: {
          color: '$statusInfo',
        },
        _dark: {
          bg: '$statusInfoSubtle',
          borderColor: '$statusInfo',
          _text: {
            color: '$statusInfo',
          },
          _icon: {
            color: '$statusInfo',
          },
        },
      },
      muted: {
        bg: '$bgSubtle',
        borderColor: '$borderLight',
        _icon: {
          color: '$textSubtle',
        },
        _text: {
          color: '$textSubtle',
        },
        _dark: {
          bg: '$bgSubtle',
          borderColor: '$borderLight',
          _text: {
            color: '$textSubtle',
          },
          _icon: {
            color: '$textSubtle',
          },
        },
      },
    },

    variant: {
      solid: {},
      outline: {
        borderWidth: '$1',
      },
    },

    size: {
      xs: {
        px: '$1.5',
        _icon: {
          props: {
            size: '3xs',
          },
        },
        _text: {
          props: {
            size: '3xs',
          },
        },
      },
      sm: {
        px: '$2',
        _icon: {
          props: {
            size: '2xs',
          },
        },
        _text: {
          props: {
            size: '2xs',
          },
        },
      },
      md: {
        px: '$2',
        _icon: {
          props: {
            size: 'xs',
          },
        },
        _text: {
          props: {
            size: 'xs',
          },
        },
      },
      lg: {
        px: '$2',
        _icon: {
          props: { size: 'sm' },
        },
        _text: {
          props: { size: 'sm' },
        },
      },
    },
  },

  ':disabled': {
    opacity: 0.5,
  },
  defaultProps: {
    action: 'info',
    variant: 'solid',
    size: 'md',
  },
});
